import React, { useEffect, useState, useContext } from 'react'
import AuctionTableView from '@/product/components/organisms/Template/Auction/TableView'
import { Button } from '@mui/material'
import Layout from '@/product/components/templates/Layout'
import DynamicListing from './dynamicListing'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
// import ReportContext from '@/product/context/report/reportContext'
import AuctionDynamic from '../../AuctionLots/dynamicListing'
import { handleRedirectInternal } from '@/product/common/components'
import { useHistory } from 'react-router-dom'

const AuctionLots = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const history = useHistory()

    const { auction_tablefields } = dynamicContext

    // const { getAllExportDownload } = useContext(ReportContext)

    const [searchInfo, setSearchInfo] = useState({})
    const [tableValue, setTableValue] = useState([])
    const [manage, setManage] = useState({
        popup: false,
        status: 'newTemplate',
        id: 0,
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        // console.log(popup, status, id, 'toggle')
        // if (popup) {
        //     setManage({ popup, status, id })
        // } else {
        //     setManage({ popup, status: 'newTemplate', id: 0 })
        // }
        if (popup && status == 'editTemplate') {
            handleRedirectInternal(
                history,
                `templates/auction/editTemplate/${id}`
            )
        } else if (popup && status == 'useTemplate') {
            handleRedirectInternal(history, `auction/use/${id}`)
        }
    }

    let action = props.match.params.action

    const custom = {
        action: {
            value: action == 'upcomming' ? 'open' : action,
            type: 'in',
            field: 'ac.market_status',
        },
    }

    useEffect(() => {
        if (auction_tablefields && auction_tablefields.length) {
            let dynamicValueAssign = {}
            let searchData = auction_tablefields
            setTableValue(searchData)
            dynamicValueAssign.data = searchData
                .filter((item) => item.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                        template: 1,
                    })
                })
            setSearchInfo(dynamicValueAssign)
        }
    }, [auction_tablefields, action])

    return (
        <>
            <Layout>
                <div className="dashboard listing maillisting">
                    <div className="miscActions d-flex justify-content-between align-items-center mt-4">
                        <Button
                            id="dynamicAuction_add"
                            variant="outlined"
                            className="btnOutlined"
                            onClick={() =>
                                handleRedirectInternal(
                                    history,
                                    `templates/auction/newTemplate/0`
                                )
                            }
                        >
                            <span className="material-icons">add</span>Add New
                            Template
                        </Button>

                        {/* <Button
                            id="dynamicAuction_report"
                            onClick={() =>
                                getAllExportDownload({
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    report: `${action}_product_management`,
                                })
                            }
                        >
                            <span className="material-icons">get_app</span>Export All Data
                        </Button> */}
                    </div>

                    <AuctionTableView
                        searchInfo={searchInfo}
                        customFilter={custom}
                        tableValue={tableValue}
                        toggleFullScreenPopup={toggleFullScreenPopup}
                        tableActionString={
                            global?.tempAuct_tableActionString
                                ? global?.tempAuct_tableActionString
                                : []
                        }
                        action={action}
                        showInvoice={
                            global?.tempAuct_showInvoice
                                ? global?.tempAuct_showInvoice
                                : false
                        }
                        columnStorageVariable={'table_auction_template'}
                    />
                </div>
                {/* <AuctionDynamic
                    data={manage}
                    function={toggleFullScreenPopup}
                />
                <DynamicListing
                    data={manage}
                    function={toggleFullScreenPopup}
                /> */}
            </Layout>
        </>
    )
}

export default AuctionLots
